module.exports = __webpack_public_path__ + "img/oxford2.48341c2f.png";